import { EventEmitter, Input, Output, Component, ChangeDetectionStrategy, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@angular/router';

function Steps_li_2_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 7);
    ɵngcc0.ɵɵlistener("click", function Steps_li_2_a_2_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r8 = ɵngcc0.ɵɵnextContext(); const item_r1 = ctx_r8.$implicit; const i_r2 = ctx_r8.index; const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.itemClick($event, item_r1, i_r2); })("keydown.enter", function Steps_li_2_a_2_Template_a_keydown_enter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r10 = ɵngcc0.ɵɵnextContext(); const item_r1 = ctx_r10.$implicit; const i_r2 = ctx_r10.index; const ctx_r9 = ɵngcc0.ɵɵnextContext(); return ctx_r9.itemClick($event, item_r1, i_r2); });
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    const item_r1 = ctx_r11.$implicit;
    const i_r2 = ctx_r11.index;
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("href", item_r1.url, ɵngcc0.ɵɵsanitizeUrl)("target", item_r1.target)("id", item_r1.id)("tabindex", item_r1.disabled || i_r2 !== ctx_r4.activeIndex && ctx_r4.readonly ? null : item_r1.tabindex ? item_r1.tabindex : "0");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(i_r2 + 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1.label);
} }
const _c0 = function () { return { exact: false }; };
function Steps_li_2_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 10);
    ɵngcc0.ɵɵlistener("click", function Steps_li_2_a_3_Template_a_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); const item_r1 = ctx_r14.$implicit; const i_r2 = ctx_r14.index; const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.itemClick($event, item_r1, i_r2); })("keydown.enter", function Steps_li_2_a_3_Template_a_keydown_enter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r16 = ɵngcc0.ɵɵnextContext(); const item_r1 = ctx_r16.$implicit; const i_r2 = ctx_r16.index; const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.itemClick($event, item_r1, i_r2); });
    ɵngcc0.ɵɵelementStart(1, "span", 8);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span", 9);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    const item_r1 = ctx_r17.$implicit;
    const i_r2 = ctx_r17.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", item_r1.routerLink)("queryParams", item_r1.queryParams)("routerLinkActive", "ui-menuitem-link-active")("routerLinkActiveOptions", item_r1.routerLinkActiveOptions || ɵngcc0.ɵɵpureFunction0(15, _c0))("fragment", item_r1.fragment)("queryParamsHandling", item_r1.queryParamsHandling)("preserveFragment", item_r1.preserveFragment)("skipLocationChange", item_r1.skipLocationChange)("replaceUrl", item_r1.replaceUrl)("state", item_r1.state);
    ɵngcc0.ɵɵattribute("target", item_r1.target)("id", item_r1.id)("tabindex", item_r1.disabled || i_r2 !== ctx_r5.activeIndex && ctx_r5.readonly ? null : item_r1.tabindex ? item_r1.tabindex : "0");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(i_r2 + 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(item_r1.label);
} }
const _c1 = function (a0, a1, a2, a3) { return { "ui-state-highlight ui-steps-current": a0, "ui-state-default": a1, "ui-state-complete": a2, "ui-state-disabled ui-steps-incomplete": a3 }; };
function Steps_li_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 3, 4);
    ɵngcc0.ɵɵtemplate(2, Steps_li_2_a_2_Template, 5, 6, "a", 5);
    ɵngcc0.ɵɵtemplate(3, Steps_li_2_a_3_Template, 5, 16, "a", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const i_r2 = ctx.index;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(item_r1.styleClass);
    ɵngcc0.ɵɵproperty("ngStyle", item_r1.style)("ngClass", ɵngcc0.ɵɵpureFunction4(8, _c1, i_r2 === ctx_r0.activeIndex, i_r2 !== ctx_r0.activeIndex, i_r2 < ctx_r0.activeIndex, item_r1.disabled || i_r2 !== ctx_r0.activeIndex && ctx_r0.readonly));
    ɵngcc0.ɵɵattribute("aria-selected", i_r2 === ctx_r0.activeIndex)("aria-expanded", i_r2 === ctx_r0.activeIndex);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !item_r1.routerLink);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.routerLink);
} }
const _c2 = function (a1) { return { "ui-steps ui-widget ui-helper-clearfix": true, "ui-steps-readonly": a1 }; };
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
let Steps = class Steps {
    constructor() {
        this.activeIndex = 0;
        this.readonly = true;
        this.activeIndexChange = new EventEmitter();
    }
    itemClick(event, item, i) {
        if (this.readonly || item.disabled) {
            event.preventDefault();
            return;
        }
        this.activeIndexChange.emit(i);
        if (!item.url) {
            event.preventDefault();
        }
        if (item.command) {
            item.command({
                originalEvent: event,
                item: item,
                index: i
            });
        }
    }
};
Steps.ɵfac = function Steps_Factory(t) { return new (t || Steps)(); };
Steps.ɵcmp = ɵngcc0.ɵɵdefineComponent({ type: Steps, selectors: [["p-steps"]], inputs: { activeIndex: "activeIndex", readonly: "readonly", model: "model", style: "style", styleClass: "styleClass" }, outputs: { activeIndexChange: "activeIndexChange" }, decls: 3, vars: 7, consts: [[3, "ngClass", "ngStyle"], ["role", "tablist"], ["class", "ui-steps-item", "role", "tab", 3, "ngStyle", "class", "ngClass", 4, "ngFor", "ngForOf"], ["role", "tab", 1, "ui-steps-item", 3, "ngStyle", "ngClass"], ["menuitem", ""], ["class", "ui-menuitem-link", "role", "presentation", 3, "click", "keydown.enter", 4, "ngIf"], ["role", "presentation", "class", "ui-menuitem-link", 3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click", "keydown.enter", 4, "ngIf"], ["role", "presentation", 1, "ui-menuitem-link", 3, "click", "keydown.enter"], [1, "ui-steps-number"], [1, "ui-steps-title"], ["role", "presentation", 1, "ui-menuitem-link", 3, "routerLink", "queryParams", "routerLinkActive", "routerLinkActiveOptions", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "click", "keydown.enter"]], template: function Steps_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "ul", 1);
        ɵngcc0.ɵɵtemplate(2, Steps_li_2_Template, 4, 13, "li", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.styleClass);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c2, ctx.readonly))("ngStyle", ctx.style);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.model);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgStyle, ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc2.RouterLinkWithHref, ɵngcc2.RouterLinkActive], encapsulation: 2 });
__decorate([
    Input()
], Steps.prototype, "activeIndex", void 0);
__decorate([
    Input()
], Steps.prototype, "model", void 0);
__decorate([
    Input()
], Steps.prototype, "readonly", void 0);
__decorate([
    Input()
], Steps.prototype, "style", void 0);
__decorate([
    Input()
], Steps.prototype, "styleClass", void 0);
__decorate([
    Output()
], Steps.prototype, "activeIndexChange", void 0);
let StepsModule = class StepsModule {
};
StepsModule.ɵmod = ɵngcc0.ɵɵdefineNgModule({ type: StepsModule });
StepsModule.ɵinj = ɵngcc0.ɵɵdefineInjector({ factory: function StepsModule_Factory(t) { return new (t || StepsModule)(); }, imports: [[CommonModule, RouterModule],
        RouterModule] });
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(Steps, [{
        type: Component,
        args: [{
                selector: 'p-steps',
                template: `
        <div [ngClass]="{'ui-steps ui-widget ui-helper-clearfix':true,'ui-steps-readonly':readonly}" [ngStyle]="style" [class]="styleClass">
            <ul role="tablist">
                <li *ngFor="let item of model; let i = index" class="ui-steps-item" #menuitem [ngStyle]="item.style" [class]="item.styleClass" role="tab" [attr.aria-selected]="i === activeIndex" [attr.aria-expanded]="i === activeIndex"
                    [ngClass]="{'ui-state-highlight ui-steps-current':(i === activeIndex),
                        'ui-state-default':(i !== activeIndex),
                        'ui-state-complete':(i < activeIndex),
                        'ui-state-disabled ui-steps-incomplete':item.disabled||(i !== activeIndex && readonly)}">
                    <a *ngIf="!item.routerLink" [attr.href]="item.url" class="ui-menuitem-link" role="presentation" (click)="itemClick($event, item, i)" (keydown.enter)="itemClick($event, item, i)" [attr.target]="item.target" [attr.id]="item.id" 
                        [attr.tabindex]="item.disabled||(i !== activeIndex && readonly) ? null : (item.tabindex ? item.tabindex : '0')">
                        <span class="ui-steps-number">{{i + 1}}</span>
                        <span class="ui-steps-title">{{item.label}}</span>
                    </a>
                    <a *ngIf="item.routerLink" [routerLink]="item.routerLink" [queryParams]="item.queryParams" role="presentation" [routerLinkActive]="'ui-menuitem-link-active'" [routerLinkActiveOptions]="item.routerLinkActiveOptions||{exact:false}" class="ui-menuitem-link" 
                        (click)="itemClick($event, item, i)" (keydown.enter)="itemClick($event, item, i)" [attr.target]="item.target" [attr.id]="item.id" [attr.tabindex]="item.disabled||(i !== activeIndex && readonly) ? null : (item.tabindex ? item.tabindex : '0')"
                        [fragment]="item.fragment" [queryParamsHandling]="item.queryParamsHandling" [preserveFragment]="item.preserveFragment" [skipLocationChange]="item.skipLocationChange" [replaceUrl]="item.replaceUrl" [state]="item.state">
                        <span class="ui-steps-number">{{i + 1}}</span>
                        <span class="ui-steps-title">{{item.label}}</span>
                    </a>
                </li>
            </ul>
        </div>
    `,
                changeDetection: ChangeDetectionStrategy.Default
            }]
    }], function () { return []; }, { activeIndex: [{
            type: Input
        }], readonly: [{
            type: Input
        }], activeIndexChange: [{
            type: Output
        }], model: [{
            type: Input
        }], style: [{
            type: Input
        }], styleClass: [{
            type: Input
        }] }); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(StepsModule, { declarations: function () { return [Steps]; }, imports: function () { return [CommonModule, RouterModule]; }, exports: function () { return [Steps,
        RouterModule]; } }); })();
/*@__PURE__*/ (function () { ɵngcc0.ɵsetClassMetadata(StepsModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule, RouterModule],
                exports: [Steps, RouterModule],
                declarations: [Steps]
            }]
    }], null, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Steps, StepsModule };

//# sourceMappingURL=primeng-steps.js.map